import { render } from "./MultiPositionCommonErrors.vue?vue&type=template&id=63353db7&scoped=true"
import script from "./MultiPositionCommonErrors.vue?vue&type=script&lang=js"
export * from "./MultiPositionCommonErrors.vue?vue&type=script&lang=js"

import "./MultiPositionCommonErrors.vue?vue&type=style&index=0&id=63353db7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63353db7"]])

export default __exports__